import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { grey } from "@mui/material/colors";
import DescriptionIcon from "@mui/icons-material/Description";
import dayjs from "dayjs";
import { exportProductionForecastGroup } from "api/resources/productionForecasts";
import { downloadXLSX } from "helpers/excelExport";

interface ForecastActionsProps {
  createdAt: string;
  groupId: number;
  filters: any;
  setSnackbar: any;
}

const ForecastActions: React.FC<ForecastActionsProps> = ({
  createdAt,
  groupId,
  filters,
  setSnackbar,
}) => {
  const [loading, setLoading] = useState(false);

  const handleExportForecastGroup = () => {
    setLoading(true);

    exportProductionForecastGroup(groupId, filters)
      .then((result) => {
        downloadXLSX(result, "Forecast_group.xlsx");
        setSnackbar({
          type: "success",
          message: "Production forecast group exported",
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setSnackbar({
          type: "error",
          message: error.message,
        });
        setLoading(false);
      });
  };
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Box>
          <LoadingButton
            variant="outlined"
            size="small"
            loading={loading}
            startIcon={<DescriptionIcon />}
            loadingIndicator="Exporting..."
            onClick={handleExportForecastGroup}
          >
            Export
          </LoadingButton>
        </Box>
      </Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        {createdAt && (
          <Typography
            component="p"
            fontSize="0.9rem"
            color={grey[700]}
            align="right"
          >
            {`Created at ${dayjs(createdAt).format("DD.MM.YYYY HH:mm")}`}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ForecastActions;
